var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "svg-icon",
      staticStyle: {
        width: "1em",
        height: "1em",
        "vertical-align": "middle",
        fill: "currentColor",
        overflow: "hidden"
      },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024",
        version: "1.1"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M280.84 383.46h504v275.71a196.5 196.5 0 0 1-196.5 196.5h-111a196.5 196.5 0 0 1-196.5-196.5V383.46z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M231.93 245.91h552.93a13.62 13.62 0 1 0 0-27.25H231.93a13.62 13.62 0 1 0 0 27.25zM218.3 640.1a229.19 229.19 0 0 0 229.2 229.19h121.79A229.19 229.19 0 0 0 798.48 640.1V324H218.3zM569.29 842H447.5c-111.35 0-201.94-90.59-201.94-201.94V477.78h525.67V640.1c0 111.35-90.59 201.9-201.94 201.9z m201.94-490.74v99.28h-82.7a13.56 13.56 0 0 0 3.47-9.06v-74.83a13.62 13.62 0 1 0-27.25 0v74.82a13.56 13.56 0 0 0 3.47 9.06H557.85a13.56 13.56 0 0 0 3.47-9.06v-74.82a13.62 13.62 0 1 0-27.25 0v74.82a13.56 13.56 0 0 0 3.47 9.06h-292v-99.27z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M374.51 746.13a145.7 145.7 0 0 1-58.25-117.06 13.62 13.62 0 1 0-27.25 0 172.16 172.16 0 0 0 18.8 78.75 175.56 175.56 0 0 0 50.24 60 13.62 13.62 0 1 0 16.45-21.72zM463 775.8a146.8 146.8 0 0 1-43-6.41 13.62 13.62 0 0 0-8 26.05 174.07 174.07 0 0 0 51 7.6 13.62 13.62 0 0 0 0-27.25z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }